// import jsLogger from 'js-logger'

export class PingStats {
  private _values: number[] = []
  private max = 10

  add(ping: number) {
    this._values.push(ping)
    if (this._values.length > this.max) {
      this._values.shift()
    }
    // jsLogger.log('BACK: ping', { values: this.values })
  }

  get avg() {
    return this._values.reduce((a, b) => a + b, 0) / this._values.length
  }

  get jitter() {
    const avg = this.avg
    return Math.sqrt(
      this._values.reduce((s, v) => s + Math.pow(v - avg, 2), 0) /
        this._values.length
    )
  }

  get values() {
    return this._values
  }
}
